import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";
import { NotFound } from "./components/Layout.js";
import { preferredLocale } from "./locale.js";
import { LocaleLayout } from "./LocaleLayout.js";
import { ClaimPage } from "./pages/ClaimPage.js";
import { HomePage } from "./pages/HomePage.js";
import { IntroPage } from "./pages/IntroPage.js";
import { InvitePage } from "./pages/InvitePage.js";
import { LegalPage } from "./pages/LegalPage.js";
import { LoginPage } from "./pages/LoginPage.js";
import { MePage } from "./pages/MePage.js";
import { MeResultPage } from "./pages/MeResultPage.js";
import { PreviewPage } from "./pages/PreviewPage.js";
import { ResultPage } from "./pages/ResultPage.js";
import { SessionPage } from "./pages/SessionPage.js";

const GalleryPage = lazy(() => import("./pages/GalleryPage.js").then((m) => ({ default: m.GalleryPage })));
// Stránka páru kreslí portréty: kód portrétu jen na ní (NFR-003 rozpočet hlavního balíku).
const PairPage = lazy(() => import("./pages/PairPage.js").then((m) => ({ default: m.PairPage })));
const PortraitPage = lazy(() => import("./pages/PortraitPage.js").then((m) => ({ default: m.PortraitPage })));

// Jazyk je v URL (DEC-001). Kořen přesměruje podle jazyka prohlížeče (REQ-017). Adresa úvodu
// `/{jazyk}/test/{slug}` je návrh z REQ-018, sezení `/{jazyk}/s/{id}` nese jen ID (token je
// v zařízení, REQ-019).
export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={`/${preferredLocale(typeof navigator === "undefined" ? [] : navigator.languages)}/`} replace />} />
      <Route path="/:lang" element={<LocaleLayout />}>
        <Route index element={<HomePage />} />
        <Route path="test/:slug" element={<IntroPage />} />
        <Route path="s/:id" element={<SessionPage />} />
        <Route
          path="s/:id/portrait"
          element={
            <Suspense fallback={null}>
              <PortraitPage kind="session" />
            </Suspense>
          }
        />
        <Route path="r/:token" element={<ResultPage />} />
        <Route path="preview/:token" element={<PreviewPage />} />
        <Route path="t/:token" element={<ClaimPage />} />
        <Route path="t" element={<ClaimPage />} />
        <Route path="me" element={<MePage />} />
        <Route path="me/results/:id" element={<MeResultPage />} />
        <Route
          path="me/results/:id/portrait"
          element={
            <Suspense fallback={null}>
              <PortraitPage kind="identity" />
            </Suspense>
          }
        />
        <Route path="p/:token" element={<InvitePage />} />
        <Route path="p" element={<InvitePage />} />
        <Route
          path="pairs/:id"
          element={
            <Suspense fallback={null}>
              <PairPage />
            </Suspense>
          }
        />
        <Route path="l/:token" element={<LoginPage />} />
        <Route path="l" element={<LoginPage />} />
        <Route path="terms" element={<LegalPage />} />
        <Route path="privacy" element={<LegalPage />} />
        <Route
          path="_galerie"
          element={
            <Suspense fallback={null}>
              <GalleryPage />
            </Suspense>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
